import $ from 'jquery';
// a basic accordion. on load
$( function() {
  $( '.accordion .title' ).on( 'click', function(e) {
    e.preventDefault();

    var $this = $( this );
    var accordion = $this.parent();
    var content = $this.next();

    accordion.parent().find( '.content' ).css( { 'max-height': '0', 'margin-top': '0' } );

    if (accordion.hasClass( 'open' ) ) {
      accordion.removeClass( 'open' );

      $this.children( '.cpt-card-info' ).animate({ 'opacity': 0 }, 0, function(){
        $this.children( '.cpt-card-info' ).html('More Info').animate({ 'opacity': 1 }, 270);    
    });
    } else {
      accordion.siblings().removeClass( 'open' );
      accordion.addClass( 'open' );
      content.css( { 'max-height': content[0].scrollHeight, 'margin-top': '1rem' } );

      $this.children( '.cpt-card-info' ).animate({ 'opacity': 0 }, 0, function(){
        $this.children( '.cpt-card-info' ).html('Less Info').animate({ 'opacity': 1 }, 270);    
    });
    }
  });
})